import React from 'react';

import AppCommHandler from '../api/AppCommHandler';

class ReconfirmTC extends React.Component {

    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
        this.goBack = this.goBack.bind(this);
    }
    goBack() {
        this.props.history.push(window.env.appcontext + '/termandcondition');
    }
    logout() {
        this.props.history.push(window.env.appcontext+"/logout");
    }
    componentDidMount() {
		AppCommHandler.APIBreadcrumbEvent("TERMS AND CONDITIONS");
    }
    render() {
        return (

            <div className="">
                <div class="card card card-shadow">
                    <div class="card-heading card-header-body-content">
                        <div class="grid-main-heading">
                            <span class="main-title">TERMS AND CONDITIONS</span>
                        </div>
                    </div>
                    <div class="card card-body card-body-body-content text-center">
                        <div class="alert alert-warning">Are you sure you would like to decline? If this was submitted in error, please click "Go Back", review the "Terms and Conditions" and click "Agree" to access your online account information.</div>
                    </div>
                    <div class="card card card-button-group">
                        <div class="mb-3">
                            <button id="agree" type="button" class="btn btn-sm btn-primary btn-ok" onClick={this.goBack}>Go Back</button>
                            <button id="disagree" type="button" class="btn btn-sm btn-secondary btn-cancel" onClick={this.logout}>Logout</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReconfirmTC;